import { invariantResponse } from '@epic-web/invariant'
import { json, type LoaderFunctionArgs } from '@remix-run/node'
import { Link, useLoaderData, type MetaFunction } from '@remix-run/react'
import { GeneralErrorBoundary } from '#app/components/error-boundary.tsx'
import { brandName } from '#app/components/branding.js'
import { getSkills, getSkillsByServerName, getSkillBySlug } from '#app/utils/skills.server.js'
import { getScriptBySlug } from '#app/utils/scripts.server.js'
import RoadmapTodoItem from '#app/components/roadmapTodoItem.js'

export async function loader({ params }: LoaderFunctionArgs) {
	const result = await getSkillBySlug(params.skillSlug || "")
	invariantResponse(result, 'Skill not found', { status: 404 })
    return json({ result })
}

export default function ProfileRoute() {
	const data = useLoaderData<typeof loader>()
	const skill = data.result;

	return (
		<div className="container mb-48 mt-6 flex flex-col items-center justify-center">
		<div className="flex flex-wrap items-center justify-center">
			<h1 className="text-center text-h2">{skill.name}</h1>
		</div>
		<p className="mt-2 text-center text-muted-foreground">
			<RoadmapTodoItem type="Skill details" />

			{/* <a href={script.slug} className="hover:no-underline"><span className="underline">{script.slug}</span>
				<ArrowTopRightOnSquareIcon aria-hidden="true" className="h-6 w-6 inline p-1" />
			</a> */}
		</p>
			{/* <div className="container flex flex-col rounded-3xl bg-muted mt-4 pt-4 p-12">
				<div>Description: {script.description || "No description provided"}</div>
				<div>hotkey: {script.hotkey || "No hotkey provided"}</div>
				<div>size: {script.size || "No size provided"}</div>
				<div>category: {script.category || "No category provided"}</div>
				<div>tags: {script.tags || "No tags provided"}</div>
				<div>skills: {script.skills || "No skills provided"}</div>
				<div>server: {script.server || "No server provided"}</div>
				<div>user: {script.creatorId}</div>
				<div>fileType: {script.fileType || "No file type provided"}</div>
				<div>Hotkey: {script.hotkeyCtrl ? "CTRL" : ""} {script.hotkeyShift ? "SHIFT" : ""} {script.hotkeyAlt ? "ALT" : ""} {script.hotkey.toUpperCase()}</div>
				<div className="text-left">
					{script.content}
				</div>
			</div> */}

			<Link to="/scripts" className="mt-8 underline hover:no-underline">View list of scripts</Link>
			
		</div>
	)
}

export const meta: MetaFunction<typeof loader> = ({ data, params }) => {
	const displayName = data?.result.name ?? params.scriptSlug
	return [
		{ title: `${displayName} | ${brandName}` },
		{
			name: 'description',
			content: `Script ${displayName} on ${brandName}`,
		},
	]
}

export function ErrorBoundary() {
	return (
		<GeneralErrorBoundary
			statusHandlers={{
				404: ({ params }) => (
					<div className="text-center">
						<p className="m-4">Cannot find a skill related to: <br />"{params.skillSlug}"<br /> reach out if you think it should be added.</p>
						<Link to="/skills" className="text-xl underline hover:no-underline">&lt; Back to all skills</Link>
					</div>					
				),
			}}
		/>
	)
}
